import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { locales } from "../../locales";
import { formatNumber } from "../../utils/communesUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    // y: {
    //   ticks: {
    //     // Include the "%" sign after the number
    //     callback: function (value, index, values) {
    //       return value + "%";
    //     },
    //   },
    // },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          var label = context.dataset.label || "";

          if (label) {
            label += ": ";
          }
          if (context.parsed.y !== null) {
            label += formatNumber(context.parsed.y);
          }
          return label;
        },
      },
    },
  },
};

function PreviousResult({ data, langId }) {
  const filteredData = data.filter((item) => item.votes > 0).reverse();
  const labels = filteredData.map((item) => item.year);
  const dataObj = filteredData.map((item) => item.votes);
  const colorObj = data.map((item) =>
    item.year === 2023 ? "#006692" : "#006692"
  );

  const chartData = {
    labels,
    datasets: [
      {
        label: locales[langId].votes,
        data: dataObj,
        backgroundColor: colorObj,
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
}

export default PreviousResult;
